module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('data-table', {
    attrs: {
      "data-set": _vm.subscriptions,
      "page-length": 50,
      "columns": [{
          name: 'Email',
          prop: 'email',
          type: 'text'
        },
        {
          name: 'MC_UNIQUE_ID',
          prop: 'mc_unique_id',
          type: 'text'
        },
        {
          name: 'Status',
          prop: 'subscribed',
          type: 'boolean'
        },
        {
          name: 'Unsub Reason',
          prop: 'unsubscribe_reason',
          type: 'text'
        },
        {
          name: 'Created',
          prop: 'created_at',
          type: 'date',
          filter: ['moment', ['from', 'now']]
        },
        {
          name: 'Updated',
          prop: 'updated_at',
          type: 'date',
          filter: ['moment', ['from', 'now']]
        } ]
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27b2b89f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/mailing/Subscriptions.vue
// module id = 514
// module chunks = 0